import { create } from 'zustand';

export interface ToastMessage {
  id: number;
  text: string;
}

interface ToastState {
  messages: ToastMessage[];
  push: (text: string) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToastStore = create<ToastState>((set) => ({
  messages: [],
  push: (text) => set((s) => ({ messages: [...s.messages, { id: nextId++, text }] })),
  dismiss: (id) => set((s) => ({ messages: s.messages.filter((m) => m.id !== id) })),
}));
